import { render, staticRenderFns } from "./ChipSelector.vue?vue&type=template&id=7afcfd09&scoped=true"
import script from "./ChipSelector.vue?vue&type=script&lang=js"
export * from "./ChipSelector.vue?vue&type=script&lang=js"
import style0 from "./ChipSelector.vue?vue&type=style&index=0&id=7afcfd09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcfd09",
  null
  
)

export default component.exports